import i18n from '@/locales/i18n';
import { UNITS } from '@/app.config';

const UnitFilter = unit => (unit === UNITS.CELSIUS ? 'ºC' : 'ºF');

const UnitNameFilter = unit =>
  unit === UNITS.CELSIUS ? i18n.t('settings.unitsName.C') : i18n.t('settings.unitsName.F');

export { UnitFilter, UnitNameFilter };
